import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeaturesRoutingModule } from './features-routing.module';

import { SharedModule } from '../shared/shared.module';
import { SharedPrimengModule } from '../shared/shared-primeng.module';
import { ConfirmationService } from 'primeng/api';
import {
  BaseChartDirective,
  provideCharts,
  withDefaultRegisterables,
} from 'ng2-charts';

import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { FloatingPathsComponent } from './welcome-page/floating-paths/floating-paths.component';
import { IconsModule } from '../shared/icons.module';
import { SectionHeadingComponent } from '../shared/components/section-heading/section-heading.component';
import { StatusBadgeComponent } from '../shared/components/status-badge/status-badge.component';
import { HeaderDocumentationComponent } from '../shared/components/header-documentation/header-documentation.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DataStateComponent } from '../shared/components/data-state/data-state.component';
import { NoDataComponent } from '../shared/components/no-data/no-data.component';

import { NgxChartsModule } from '@swimlane/ngx-charts';
import { WorkNotificationComponent } from './sanitization/work-notification/work-notification.component';
import { WorkOrderComponent } from './sanitization/work-order/work-order.component';
import { SanitizationComponent } from './sanitization/sanitization.component';
import { SendingFilesComponent } from './sending-files/sending-files.component';
import { FileUploadCardComponent } from './sending-files/components/file-upload-card/file-upload-card.component';
import { HygieneTreatmentComponent } from './hygiene-treatment/hygiene-treatment.component';
import { SchedulingComponent } from './scheduling/scheduling.component';
import { SettingsComponent } from './settings/settings.component';
import { DataCleaningPanelComponent } from './settings/data-cleaning-panel/data-cleaning-panel.component';
import { FactoriesTabComponent } from './settings/factories-tab/factories-tab.component';

@NgModule({
  declarations: [
    WelcomePageComponent,
    FloatingPathsComponent,
    SectionHeadingComponent,
    StatusBadgeComponent,
    HeaderDocumentationComponent,
    DataStateComponent,
    NoDataComponent,
    WorkNotificationComponent,
    WorkOrderComponent,
    SanitizationComponent,
    SendingFilesComponent,
    FileUploadCardComponent,
    HygieneTreatmentComponent,
    SchedulingComponent,
    SettingsComponent,
    DataCleaningPanelComponent,
    FactoriesTabComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    FeaturesRoutingModule,
    SharedModule,
    SharedPrimengModule,
    BaseChartDirective,
    IconsModule,
    NgxChartsModule,
  ],
  providers: [ConfirmationService, provideCharts(withDefaultRegisterables())],
})
export class FeaturesModule {}
